/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaxCheckBool, PaxCheckBoolFromJSONTyped, PaxCheckBoolToJSON } from "./PaxCheckBool";
import { PaxCheckFromList, PaxCheckFromListFromJSONTyped, PaxCheckFromListToJSON } from "./PaxCheckFromList";


/**
 * @type PaxCheckAnswer
 * 
 * @export
 */
export type PaxCheckAnswer = { type: 'bool-answer' } & PaxCheckBool | { type: 'from-list-answer' } & PaxCheckFromList;

export function PaxCheckAnswerFromJSON(json: any): PaxCheckAnswer {
    return PaxCheckAnswerFromJSONTyped(json, false);
}

export function PaxCheckAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAnswer {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'bool-answer':
            return Object.assign({}, PaxCheckBoolFromJSONTyped(json, true), { type: 'bool-answer' } as const);
        case 'from-list-answer':
            return Object.assign({}, PaxCheckFromListFromJSONTyped(json, true), { type: 'from-list-answer' } as const);
        default:
            return json;
    }
}

export function PaxCheckAnswerToJSON(json: any): any {
    return PaxCheckAnswerToJSONTyped(json, false);
}

export function PaxCheckAnswerToJSONTyped(value?: PaxCheckAnswer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'bool-answer':
            return Object.assign({}, PaxCheckBoolToJSON(value), { type: 'bool-answer' } as const);
        case 'from-list-answer':
            return Object.assign({}, PaxCheckFromListToJSON(value), { type: 'from-list-answer' } as const);
        default:
            return value;
    }
}

